import { Fragment, useEffect, useMemo } from "react";
import { WithSideAds } from "components/ads";
import { HomepageSkyscraperEnum } from "components/ads/config/units/homepageSkyscraper";
import { HomeFeed } from "components/home/HomeFeed";
import { useSelector } from "react-redux";
import { IAppState } from "store/app-state";
import { Loader } from "components/UI/Loader";
import { tabValues } from "components/home/HomeTab";
import "pages/common.scss";
import "./HomePage.scss";

export const HomePage = () => {
  const currentUser = useSelector((state: IAppState) => state.user.currentUser);
  const isLoading = useSelector((state: IAppState) => state.user.loadingCurrentUser);

  const isUserLoggedIn = useMemo(() => {
    return currentUser && (Object.entries(currentUser).length > 0);
  }, [currentUser]);

  const tab = useMemo(() => {
    return isUserLoggedIn ? tabValues.FOR_YOU : tabValues.TRENDING;
  }, [isUserLoggedIn]);

  useEffect(() => {
    document.title = "Porn Gifs and Porn Pics | RedGIFs";
  }, []);

  return (
    <Fragment>
      <WithSideAds
        leftAds={[
          HomepageSkyscraperEnum.HomepageSkyscraperL1,
        ]}
        rightAds={[
          HomepageSkyscraperEnum.HomepageSkyscraperR1,
        ]}
      >
        <div className="page homePage feed">
          { isLoading ? <Loader /> : <HomeFeed tab={tab} isUserLoggedIn={isUserLoggedIn} />}
        </div>
      </WithSideAds>
    </Fragment>
  );
};

export default HomePage;
